import { useTranslation } from 'react-i18next';

/** @deprecated Prefer inner frame on AdaptiveAddToCartLabel; kept for tests migrating off button-level CQ. */
export const RP_ADD_CTA_CONTAINER_CLASS = 'rp-add-cta';

/** Forces long copy (detail-sheet full-width footer). */
export const RP_ADD_CTA_ALWAYS_LONG_CLASS = 'rp-add-cta--always-long';

export type AdaptiveAddToCartLabelProps = {
  /** i18n key for narrow buttons (default `shop.add`). */
  readonly shortKey?: string;
  /** i18n key when the button is wide enough (default `shop.addToCart`). */
  readonly longKey?: string;
  /**
   * Full-width footers (offer detail sheet) — always show long copy.
   * Grid card cells use adaptive CQ on the inner frame instead.
   */
  readonly alwaysLong?: boolean;
};

const DEFAULT_SHORT_KEY = 'shop.add';
const DEFAULT_LONG_KEY = 'shop.addToCart';

function joinClasses(...parts: ReadonlyArray<string | undefined>): string {
  return parts.filter((part) => part !== undefined && part.length > 0).join(' ');
}

/**
 * Visible add-to-cart label — short vs long per inner frame width (shared CQ).
 * Parent button keeps block/w-full; this inner span is the CQ container so width
 * is not shrink-wrapped to the short label on inline-flex buttons.
 */
export function AdaptiveAddToCartLabel({
  shortKey = DEFAULT_SHORT_KEY,
  longKey = DEFAULT_LONG_KEY,
  alwaysLong = false,
}: AdaptiveAddToCartLabelProps): JSX.Element {
  const { t } = useTranslation('customer');

  return (
    <span
      className={joinClasses(
        RP_ADD_CTA_CONTAINER_CLASS,
        'block w-full min-w-0 text-center',
        alwaysLong ? RP_ADD_CTA_ALWAYS_LONG_CLASS : undefined,
      )}
      data-testid="customer-add-cta-frame"
    >
      <span
        className="rp-add-cta-label-short"
        data-testid="customer-add-cta-label-short"
        aria-hidden="true"
      >
        {t(shortKey)}
      </span>
      <span className="rp-add-cta-label-long" data-testid="customer-add-cta-label-long">
        {t(longKey)}
      </span>
    </span>
  );
}
